import $ from 'jquery';

/**
 * 「次の◯件を読み込む」を押下時の読み込み処理
 */
export default class MoreClick {
    constructor() {
        //次を読み込む
        $('#more_click').on('click', e => {
            const button = $(e.currentTarget);

            if (
                $('[data-pager]').length != 1 ||
                button.attr('disabled') == 'disabled'
            ) {
                return false;
            }
            const pager = $('[data-pager]');
            button.attr('disabled', '1');

            // 「検索中」文字
            this.draw_more(pager);

            // パラメータ設定
            const pager_name = pager.attr('data-pager');
            const offset = $(pager_name).length;
            $('#search_from input[name=offset]').val(offset);

            $.ajax({
                type: 'get',
                url: $('#search_from').attr('action'),
                data: $('#search_from').serialize(),
            }).done(response => {
                pager.append(response);
                $('#search_from', response).remove();
                this.draw_more(pager);
                button.removeAttr('disabled');
            });
            return false;
        });
    }

    draw_more(pager) {
        const pager_name = pager.attr('data-pager');
        const offset = $(pager_name).length;

        if ($('#display_total').text() > offset) {
            $('#more_click').show();
        } else {
            $('#more_result').hide();
        }
    }
}
